import {useMountedHostname} from "utils/useMountedHostname";
import {supportAddressFor} from "./supportAddress";

/**
 * The support inbox for the storefront this page is being served from (ui#2261).
 *
 * A thin adapter, by mandate (epic #26): the rule is {@link supportAddressFor}, React-free and unit
 * tested on its own, and {@link useMountedHostname} supplies the one input it cannot take for itself
 * plus the hydration gate that makes taking it safe. The pre-mount pass runs the SAME rule with `""`,
 * which answers the api's fallback brand, so there is no second code path to keep in step.
 */
export function useSupportAddress(): string {
	return supportAddressFor(useMountedHostname());
}
